$(document).ready(function() {
    var currentIndex = 0;
    var totalButtons = $('.thumbnail-list .thumbnail').length;
    
    $(".media--icon--right").click(function() {
        $('.slider-button--next').click();
        
        if (currentIndex < totalButtons - 1) {
            currentIndex++;
        } else {
            currentIndex = 0; // Reset index to 0 when at the last index
        }
        
        clickThumbnail(currentIndex);
    });
    
    $(".media--icon--left").click(function() {
        $('.slider-button--prev').click();
        
        if (currentIndex > 0) {
            currentIndex--;
        } else {
            currentIndex = totalButtons - 1; // Set index to last index when at 0
        }
        
        clickThumbnail(currentIndex);
    });
    
    function clickThumbnail(index) {
        var $thumbnailList = $('.thumbnail-list');
        var $buttons = $thumbnailList.find('.thumbnail');
        
        $buttons.eq(index).click();
    }

  $('.product-form__input--dropdown select').on('change', function() {
        // Get the selected option value
        var selectedValue = $(this).val();
        
        // Find the closest .slc-value and update its text
        $(this).closest('.product-form__input--dropdown').find('.slc-value').text(selectedValue);
    });

   // Event listener for click on .v-swatch elements
    $('.v-swatch').on('click', function() {
        var dataNameValue = $(this).attr('data-name');
      $(this).addClass('sw-active');
      $(this).siblings().removeClass('sw-active');
        $(this).siblings('.form__label').find('.slc-value').text(dataNameValue);
    });
});

/* Dynamic SAVE amount for product price badges. */
(() => {
  const formatSaving = (cents) => {
    let currency = window.Shopify?.currency?.active;
    if (!currency) {
      try {
        currency = JSON.parse(document.querySelector('#apple-pay-shop-capabilities')?.textContent || '{}').currencyCode;
      } catch (_) {}
    }
    currency ||= 'USD';
    const amount = cents / 100;
    const decimals = Number.isInteger(amount) ? 0 : 2;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(amount);
    } catch (_) {
      return '$' + amount.toFixed(decimals);
    }
  };

  const updateBadge = (badge) => {
    const section = badge.closest('.shopify-section') || badge.closest('section') || document;
    const picker = section.querySelector('variant-selects');
    let variants = [];
    try {
      variants = JSON.parse(picker?.querySelector('script[type="application/json"]')?.textContent || '[]');
    } catch (_) {}

    const selectedOptions = Array.from(picker?.querySelectorAll('fieldset') || []).map((fieldset) =>
      fieldset.querySelector('input[type="radio"]:checked')?.value || fieldset.querySelector('select')?.value
    );
    let variant = selectedOptions.length
      ? variants.find((item) => item.options?.every((value, index) => value === selectedOptions[index]))
      : null;
    if (!variant) {
      const variantId = section.querySelector('select[name="id"]')?.value || section.querySelector('input[name="id"]')?.value;
      variant = variants.find((item) => String(item.id) === String(variantId));
    }

    const saving = variant?.compare_at_price > variant?.price ? variant.compare_at_price - variant.price : 0;
    const nextText = saving > 0 ? 'SAVE ' + formatSaving(saving) : '';
    if (badge.textContent.trim() !== nextText) badge.textContent = nextText;
    if (badge.hidden !== !saving) badge.hidden = !saving;
    badge.setAttribute('aria-label', nextText || '');
  };

  let scheduled = false;
  const updateAll = () => {
    scheduled = false;
    document.querySelectorAll('.product__info-container .price__badge-sale').forEach(updateBadge);
  };
  const scheduleUpdate = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => setTimeout(updateAll, 0));
  };

  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects') || event.target.matches('[name="id"]')) scheduleUpdate();
  }, true);
  new MutationObserver(scheduleUpdate).observe(document.documentElement, { childList: true, subtree: true });
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', scheduleUpdate, { once: true })
    : scheduleUpdate();
})();

